module.exports = __webpack_public_path__ + "img/icon_wenhao.90ff7273.png";